// @ts-nocheck
import cn from '@core/utils/classNames';

import styles from './DecisionFactorsFlags.module.css';
import decisionFactorsFlagsIcons from './DecisionFactorsFlagsDictionary';

export interface DecisionFactor {
  label: string;
}

interface DecisionFactors {
  value: DecisionFactor[];
}

interface DecisionFactorsFlagsProps {
  decisionFactors: DecisionFactors;
  asColumn?: boolean;
}

const DecisionFactorsFlags = ({ decisionFactors, asColumn = false }: DecisionFactorsFlagsProps) => {
  if (!decisionFactors?.value) {
    return null;
  }

  return (
    <div className={cn(styles.flagContent, asColumn && styles.asColumn)}>
      {decisionFactors.value.map((flag, index) => {
        const factorKeys = Object.keys(decisionFactorsFlagsIcons);
        const matchedKey = factorKeys.find((key) => key && flag.label.toLowerCase().includes(key.toLowerCase()));
        const icon = matchedKey
          ? decisionFactorsFlagsIcons[matchedKey as keyof typeof decisionFactorsFlagsIcons]
          : decisionFactorsFlagsIcons.default;
        return (
          <div className={styles.flag} key={flag.label}>
            <span className={styles.icon}>{icon}</span>
            {flag.label}
          </div>
        );
      })}
    </div>
  );
};

export default DecisionFactorsFlags;
